export const StarIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.99984 1.66667L12.5748 6.88334L18.3332 7.725L14.1665 11.7833L15.1498 17.5167L9.99984 14.8083L4.84984 17.5167L5.83317 11.7833L1.6665 7.725L7.42484 6.88334L9.99984 1.66667Z" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}